export default {
  namespaced: true,
  state: {
    state: [
      { name: '', value: 0 },
      { name: '探し中', value: 1 },
      { name: '研修待ち', value: 2 },
      { name: '紹介待ち', value: 3 },
      { name: '初回日待ち', value: 4 },
      { name: 'complete', value: 5 },
      { name: 'cancel', value: 6 }
    ],

    matching_type: [
      { name: '', value: 0 },
      { name: '新規', value: 1 },
      { name: 'チェンジ', value: 2 },
      { name: '試し', value: 3 },
      { name: '短期', value: 4 },
      { name: '短期チェンジ', value: 5 },
      { name: '引継', value: 6 }
    ],

    change_reason: [
      { name: '', value: 0 },
      { name: 'チェンジ理由1', value: 1 },
      { name: 'チェンジ理由2', value: 2 },
      { name: 'チェンジ理由3', value: 3 }
    ],

    tel: [
      { name: '', value: 0 },
      { name: '○', value: 1 },
      { name: '留守', value: 2 },
      { name: 'TEL', value: 3 }
    ],

    check: [
      { name: '', value: 0 },
      { name: '○', value: 1 }
    ],

    zumi: [
      { name: '', value: 0 },
      { name: '済', value: 1 }
    ],

    grade: [
      { name: '', value: '' },
      { name: '幼稚園年少', value: '幼稚園年少' },
      { name: '幼稚園年中', value: '幼稚園年中' },
      { name: '幼稚園年長', value: '幼稚園年長' },
      { name: '小学1年生', value: '小学1年生' },
      { name: '小学2年生', value: '小学2年生' },
      { name: '小学3年生', value: '小学3年生' },
      { name: '小学4年生', value: '小学4年生' },
      { name: '小学5年生', value: '小学5年生' },
      { name: '小学6年生', value: '小学6年生' },
      { name: '中学1年生', value: '中学1年生' },
      { name: '中学2年生', value: '中学2年生' },
      { name: '中学3年生', value: '中学3年生' },
      { name: '高校1年生', value: '高校1年生' },
      { name: '高校2年生', value: '高校2年生' },
      { name: '高校3年生', value: '高校3年生' }
    ],

    matching_month: [
      { name: '', value: '' },
      { name: '1月', value: '1月' },
      { name: '2月', value: '2月' },
      { name: '3月', value: '3月' },
      { name: '4月', value: '4月' },
      { name: '5月', value: '5月' },
      { name: '6月', value: '6月' },
      { name: '7月', value: '7月' },
      { name: '8月', value: '8月' },
      { name: '9月', value: '9月' },
      { name: '10月', value: '10月' },
      { name: '11月', value: '11月' },
      { name: '12月', value: '12月' }
    ]
  },
  mutations: {},
  actions: {},
  getters: {
    state (state) { return state.state },
    matching_type (state) { return state.matching_type },
    change_reason (state) { return state.change_reason },
    tel (state) { return state.tel },
    check (state) { return state.check },
    zumi (state) { return state.zumi },
    grade (state) { return state.grade },
    matching_month (state) { return state.matching_month }
  }
}



// WEBPACK FOOTER //
// ./src/store/student_tutors.js